module.exports = __webpack_public_path__ + "static/media/thunderkick.621f0f74.jpeg";